import { Link, useLocation } from "react-router-dom";
import SiteHeader from "../components/feature/SiteHeader";
import SiteFooter from "../components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="text-center">
          <div className="font-heading font-black text-7xl md:text-9xl text-primary-100 select-none">
            404
          </div>
          <h1 className="mt-4 font-heading font-bold text-xl md:text-2xl text-foreground-950">
            页面不存在或已被移除
          </h1>
          <p className="mt-2 text-sm text-foreground-500">
            你访问的地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 暂时无法找到
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 mt-7 px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line" />
            返回首页
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}